import { createFileRoute, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { MobileRoot } from '@/mobile/index';
import { useAuth } from '@/lib/auth';

export const Route = createFileRoute('/m')({
  component: MobileLayout,
});

function MobileLayout() {
  const { user, loading, isPlatform, isImpersonating } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (loading) {
    return (
      <div
        style={{
          height: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg)',
        }}
      >
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 13,
            color: 'var(--fg-muted)',
          }}
        >
          Carregando…
        </span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Usuário plataforma (não impersonando) cai no Master mobile.
  // Já dentro de /m/master/* — não redireciona (evita loop).
  if (isPlatform && !isImpersonating && !pathname.startsWith('/m/master')) {
    return <Navigate to="/m/master" replace />;
  }

  // Sub-rotas /m/master/* trazem o próprio shell (MasterMobileRoot, lilac).
  // Aqui só passamos pelo Outlet pra evitar dupla shell mint+lilac.
  if (pathname.startsWith('/m/master')) {
    return <Outlet />;
  }

  return (
    <MobileRoot>
      <Outlet />
    </MobileRoot>
  );
}
